import { connect } from 'react-redux'

import { selectItem } from '../../../../common/actions/layout'

const mapDispatchToProps = dispatch => {
  return {
    selectItem: item => {
      dispatch(selectItem(item))
    }
  }
}

const createButtonContainer = component => {
  return connect(
    null,
    mapDispatchToProps
  )(component)
}

export default createButtonContainer
